"use strict";

import Vue from "vue";
import router from "./../router";
import store from "@/store";
import axios from "axios";
import qs from "qs";
import { getToken, getHdToken } from "@/utils/auth";
import httpConfig from "@/api/httpConfig";
import { Toast, Indicator } from "mint-ui";
import loading from "../components/Load";
Vue.use(loading);
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = httpConfig;

const LANG = {
  en: "en-US",
  zh: "zh-CN",
  hk: "zh-HK",
  ko: "ko-KR",
  ja: "ja-JP",
};

const _axios = axios.create(config);
const noDeedLoading = ["check", "transactions", "getVerficationMethod"];
_axios.interceptors.request.use(
  function (config) {
    if (!config.third) {
      config.headers["XX-Token"] = getToken() || "";
      config.headers["token"] = getHdToken() || "";
      config.headers["XX-Device-Type"] = window.sys || "web";
    }
    // config.headers['XX-Hd-Token'] = getHdToken() || ""
    config.url += "?lang=" + LANG[window.LS.get("language")] || "en-US";
    if (
      config.method == "post" &&
      !(config.headers["Content-Type"] === "application/json") &&
      !(config.data instanceof FormData)
    ) {
      config.data = qs.stringify(config.data, {
        indices: false,
      });
    }
    if (checkLoading(config.url)) {
      Vue.$loading.show();
      // this.$loading.show();
      // Vue.$loading.show();
      // Indicator.open();
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

function checkLoading(url) {
  let r = true;
  noDeedLoading.forEach(function (val, index) {
    if (url.indexOf(val) != -1) {
      r = false;
      return;
    }
  });
  return r;
}
// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    Indicator.close();
    Vue.$loading.hide();
    // this.$loading.hide();
    if (response.data.code == 10001) {
      store.dispatch("removeToken");
      router.replace("/login");
    }
    if (
      response.data.code != 1 &&
      response.data.code != 200 &&
      response.data.code != 20001
    ) {
      Toast(response.data.msg);
      return Promise.reject(response.data.code);
    }
    return response.data;
  },
  function (error) {
    Indicator.close();
    // Toast(error);
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  Vue.$axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);
export default Plugin;
